import React from 'react'
import styled from 'styled-components'

import {Box, BoxProps, AtlasButton, Text, SxProp, sx} from '../..'

/**
 * This is a stub. Dependent on an inline-editable text field.
 */
export interface ActionTitleProps {
  /**
   *
   */
  children?: React.ReactNode
  /**
   *
   */
}

const ActionTitle = ({children, ...props}: ActionTitleProps) => {
  return <Box>{children}</Box>
}

export default ActionTitle
